import { models } from 'powerbi-client';

interface Props {
  accessToken: string;
  embedUrl: string;
  embedId: string;
  window: number;
  activeEditorBI: boolean;
  activeViewFiltersBI: boolean;
  pageName?: string;
}
export default function reportProps({
  accessToken,
  embedUrl,
  embedId,
  window,
  activeEditorBI,
  activeViewFiltersBI,
  pageName,
}: Props) {
  const initialReportProps = {
    type: 'report',
    embedType: 'report',
    tokenType: 'Aad',
    accessToken,
    embedUrl,
    embedId,
    pageName,
    reportMode: activeEditorBI ? 'Edit' : 'View', // "Edit"
    permissions: 'All', // "All" (when using "Edit" mode)

    extraSettings: {
      filterType: models.FilterType.Basic,
      requireSingleSelection: true,
      hideErrors: true,
      navContentPaneEnabled: false,
      visualRenderedEvents: true,
      background: models.BackgroundType.Transparent,
      layoutType: window,

      panes: {
        filters: {
          expanded: false,
          visible: activeViewFiltersBI,
        },
        // As páginas aparecem na barra do SAMASC, abaixo do relatório.
        pageNavigation: {
          visible: false,
        },
      },
      // No computador o relatório ocupa a largura do container e rola na
      // vertical; no celular o Power BI usa o layout móvel do relatório.
      customLayout:
        window === models.LayoutType.Custom
          ? { displayOption: models.DisplayOption.FitToWidth }
          : undefined,
    },
  };

  return { initialReportProps };
}
